// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","booking-page__widget__container":"BookingPage_booking-page__widget__container__ZB4Vg"};